export const DELETE_LOGOS_MUTATION = `
  mutation DeleteTenantLogos($ids: [Int!]!) {
    deleteTenantLogos(ids: $ids)
  }
`;

export type DeleteLogosResponse = {
  deleteTenantLogos: Array<number>
}
